const DOCUMENT = 'AGENCIES_REMOVED_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_FAILURE: DOCUMENT + 'LOAD_FAILURE',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  RESTORE_AGENCY_REQUEST: DOCUMENT + 'RESTORE_AGENCY_REQUEST',

  loadData: data => ({ type: actions.LOAD_REQUEST, payload: data }),

  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),

  loadDataFailure: () => ({ type: actions.LOAD_FAILURE }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),

  restoreAgency: data => ({ type: actions.RESTORE_AGENCY_REQUEST, payload: data }),
};

export default actions;
